@for (category of categories; track $index) {
<ul>
  <mat-checkbox
    [(ngModel)]="category.checked"
    (ngModelChange)="onCheckChanged(category)"
    [disabled]="disabled"
    >{{category.name}}</mat-checkbox
  >
</ul>
}
